import * as R from 'ramda';

function getLatestMobileAssessment(assessments = []) {
    const sortFn = R.compose(R.last, R.sortBy(R.prop('createdOn')), R.ifElse(R.is(Array), R.identity, R.always([])));

    const [confirmed, unconfirmed] = R.compose(
        R.over(R.lensIndex(1), sortFn),
        R.over(R.lensIndex(0), sortFn),
        R.partition(R.prop('confirmed'))
    )(assessments);

    if (R.isNotNil(confirmed)) {
        return confirmed;
    }
    return unconfirmed || null;
}

export default getLatestMobileAssessment;
